import { ICreateWording, TWordingLevel, IUpdateWordings } from 'types';
import {
	serviceGetAllWordingsInfo,
	serviceCreateWording,
	serviceDeleteWording,
	serviceUpdateWordings,
	serviceGetWordingCategories,
} from 'services/api/adminSettings';
import { createAppErrorMessage } from 'utils/helpers';

const getAllWordingsInfo = async () => {
	try {
		const response = await serviceGetAllWordingsInfo();
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createWording = async (data: ICreateWording) => {
	try {
		await serviceCreateWording(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingWording');
		throw new Error(errorMessage);
	}
};

const deleteWording = async (localizationSettingsId: string, level: TWordingLevel) => {
	try {
		await serviceDeleteWording(localizationSettingsId, level);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingWording');
		throw new Error(errorMessage);
	}
};

const updateWordings = async (data: IUpdateWordings) => {
	try {
		await serviceUpdateWordings(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingWordings');
		throw new Error(errorMessage);
	}
};

const getWordingCategories = async () => {
	try {
		const response = await serviceGetWordingCategories();
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

export { getAllWordingsInfo, createWording, deleteWording, updateWordings, getWordingCategories };
